import { createContext } from 'react'

export const ProfileWidgetsHideContext = createContext(null)
